import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent } from '../base-renderer/base-renderer.component';
import { LabelValue } from '../../../../models';
import { CustomCellRendererParams } from '../../models';

@Component({
  selector: 'app-select-renderer',
  templateUrl: './select-renderer.component.html',
  styleUrl: './select-renderer.component.scss',
})
export class SelectRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  public onChange(model: LabelValue) {
    this.params.node.setDataValue(this.colId, model.value);
  }
}
